// extracted by mini-css-extract-plugin
export var active = "_2u-b";
export var activeIndicator = "_2u-6";
export var animate = "_2u-a";
export var disabled = "_2u-c";
export var flat = "_2u-1";
export var fullWidth = "_2u-3";
export var lg = "_2u-9";
export var md = "_2u-8";
export var redoButtonTabGroup = "_2u-0";
export var sm = "_2u-7";
export var tabButton = "_2u-4";
export var tabButtonsContainer = "_2u-2";
export var xs = "_2u-5";